import React from 'react';
import { useParams, useSearchParams } from 'react-router-dom';
import PublicSubscriptionPaymentUpdate from '@/components/subscription/payment-update';

const PublicPaymentUpdatePage: React.FC = () => {
  const { subscriptionId } = useParams<{ subscriptionId: string }>();
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');

  if (!subscriptionId) {
    return (
      <div className="min-h-screen bg-gradient-to-b from-white to-gray-50 pt-20">
        <div className="container mx-auto px-4 max-w-md">
          <div className="text-center">
            <h1 className="text-2xl font-bold text-gray-900 mb-4">Invalid Link</h1>
            <p className="text-gray-600">The payment update link is invalid or has expired.</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <PublicSubscriptionPaymentUpdate 
      subscriptionId={subscriptionId} 
      token={token || undefined}
    />
  );
};

export default PublicPaymentUpdatePage;